import { useState, useEffect, useRef, forwardRef } from "react";
import { useSelector, useDispatch } from "react-redux"
import { Box, Divider, IconButton, useTheme } from "@mui/material";
import { usePbiGetAllUsersMutation, usePbiGetReportPermissionMutation, usePbiUpdateReportPermissionMutation } from '../auth/authApiSlice'
import { selectPBIWorkspace, selectSelectedReportId } from "../auth/authSlice"
import { selectUserData, selectSubscriptionReportId } from "../data/dataSlice"
import { setAllUserData, selectAllUserData } from "./admindataSlice"
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import InputBase from "@mui/material/InputBase";
import SearchIcon from "@mui/icons-material/Search";
import Button from '@mui/material/Button';
import { tokens } from "../../assets/theme";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import Spinner from '../../components/Spinner'

const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });


const ReportPermission = () => {
    const dispatch = useDispatch()
    const workspaceid = useSelector(selectPBIWorkspace);
    const reportid = useSelector(selectSelectedReportId);
    const selectAllUsers = useSelector(selectAllUserData);
    const currentUserData = useSelector(selectUserData);
    const subscriptionreportid = useSelector(selectSubscriptionReportId);
    const [spinnerRPLoad, setSpinnerRPLoad] = useState(false)

    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [userSearchTxt, setUserSearchTxt] = useState("");


    const errRef = useRef()
    const [errMsg, setErrMsg] = useState('')
    const [ pbiAllUsers, { isPBIAllUsersLoading } ] = usePbiGetAllUsersMutation()
    const [ pbiUpdateReportPermission, { isPBIUpdateReportPermissionLoading } ] = usePbiUpdateReportPermissionMutation()
    const [ pbiGetReportPermission, { isPBIGetReportPermissionLoading } ] = usePbiGetReportPermissionMutation()

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [checked, setChecked] = useState([]);

    const handleGetReportPermission = async () => {
        const reportdata = {"reportId": reportid, "userID": currentUserData ? currentUserData.id : ""}
        const resData = await pbiGetReportPermission(reportdata).unwrap()
        if(resData) {
            setChecked(resData.map((item)=> item.userId))
        }
    }

    const handlePBIAllUsers = async (workspacedetail) => { 
        const userPBIData =  await pbiAllUsers(workspacedetail).unwrap()
        dispatch(setAllUserData(userPBIData))
    }

    
    useEffect(() => {
        try {
          let workspacedetail = {"wsid": workspaceid}
          handlePBIAllUsers(workspacedetail);
          handleGetReportPermission();
        } catch (err) {
            if (!err?.originalStatus) {
                setErrMsg('No Server Response');
            } else if (err.originalStatus === 400) {
                setErrMsg('Error');
            } else if (err.originalStatus === 401) {
                setErrMsg('Unauthorized');
            } else {
                setErrMsg('Error');
            }
        }
       }, [reportid])

       const handleAddUserClick = () => {
        console.log("");
       }


  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);

  };

  const initialsUserName = name => {
    let rgx = new RegExp(/(\p{L}{1})\p{L}+/, 'gu');
    
    let initials = [...name.matchAll(rgx)] || [];
    
    return ((initials.shift()?.[1] || '') + (initials.pop()?.[1] || '')).toUpperCase();
  }

  const onSuccessUpdatePermissioin = async () => {
    let reqBody = {"ReportId": subscriptionreportid, "UserId": checked, "TenantId": workspaceid}
    console.log("for paginated id");
    try {
        const responseData = await pbiUpdateReportPermission(reqBody);
    } catch (err) {
        console.log(err)
    }
  }

  const handleUpdateReportPermission = async () => {
    setSpinnerRPLoad(true)
    let reqBody = {"ReportId": reportid, "UserId": checked, "TenantId": workspaceid}
    try {
        const responseData = await pbiUpdateReportPermission(reqBody);
        console.log(subscriptionreportid);
        if(responseData && subscriptionreportid){
            onSuccessUpdatePermissioin();
        }
        setSpinnerRPLoad(false)
        setTimeout(() => {
          }, 3000);
          setOpenSnackbar(true);
          setTimeout(() => {
            setOpenSnackbar(false);
          }, 2000);
    } catch (err) {
        console.log(err)
        setSpinnerRPLoad(false)
    }
    
    // console.log(responseData)
    // setSpinnerRPLoad(false)
    // setOpenSnackbar(true);
    // if(responseData) {
    //     console.log('WAHA HA')
    // }
}

const handleCloseAlert = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnackbar(false);
  };

  return (
    <Box>
        <Box display="flex" className="reportpermissionbox">
            <Box
            flex="1 1 70%"
            p="15px"
            pl="0px"
            borderRadius="4px"
            >
            <List dense className="ul-userlistadded">
                {selectAllUsers && selectAllUsers.length == 0 && (<span>No Data Available...</span>)}
                {selectAllUsers && (
                    <>{selectAllUsers.filter((users) => {
                        return checked.some((userid) => {
                        return userid === users.id;
                          });
                        }).map((user) => {
                            return (
                            <ListItem
                                key={user.id}
                                disablePadding
                            >
                                <ListItemButton>
                                <ListItemAvatar>
                                    <Avatar>{initialsUserName(user.userName)}</Avatar>
                                </ListItemAvatar>
                                <ListItemText primary={user.userName} />
                                {/* <div>
                                    <FormControlLabel control={<Checkbox />} label="Can Create" />
                                    <FormControlLabel control={<Checkbox />} label="Can Edit" />
                                </div> */}
                                </ListItemButton>
                            </ListItem>
                            );
                        })
                    }
                    </>
                )}
                </List>
                <Divider />
                <div>
                <Stack className="divlogoutbtn" direction="row" spacing={2}>
                    <Button variant="contained" color="primary" onClick={handleUpdateReportPermission} autoFocus>Save</Button>
                    {/* <Button variant="outlined" color="primary">Cancel</Button> */}
                </Stack>
                </div>
            </Box>
            <Box
            flex="1 1 30%"
            backgroundColor={colors.primary[400]}
            p="5px"
            pt ="0px"
            borderRadius="4px"
            >
                <Box
                    display="flex"
                    backgroundColor={colors.primary[400]}
                    borderRadius="3px"
                    className="searchreportbox"
                >

                    <InputBase sx={{ ml: 2, flex: 1 }} placeholder="Search User"  onChange={e => {setUserSearchTxt(e.target.value)}}  />
                    <IconButton type="button" sx={{ p: 1 }}>
                        <SearchIcon />
                    </IconButton>
                </Box>
                <Box>
                <List dense className="ul-userlist">
                    {selectAllUsers && selectAllUsers.length == 0 && (<span>No Data Available...</span>)}
                    {selectAllUsers && (
                    <>{selectAllUsers.filter((user) => {
                        if (userSearchTxt == ""){
                           return user
                        } else if (user.userName.toLowerCase().includes(userSearchTxt.toLocaleLowerCase())) {
                          return user
                        }
                      }).map((user) => {
                        const labelId = `checkbox-list-secondary-label-${user.id}`;
                        return (
                        <ListItem
                            key={user.id}
                            secondaryAction={
                            <Checkbox
                                edge="end"
                                onChange={handleToggle(user.id)}
                                checked={checked.indexOf(user.id) !== -1}
                                inputProps={{ 'aria-labelledby': labelId }}
                            />
                            }
                            disablePadding
                        >
                            <ListItemButton>
                            <ListItemAvatar>
                                <Avatar>{initialsUserName(user.userName)}</Avatar>
                            </ListItemAvatar>
                            <ListItemText id={labelId} primary={user.userName} />
                            </ListItemButton>
                        </ListItem>
                        );
                    })}
                    </>
                    )}
                    </List>
                </Box>
            </Box>
        </Box>
        <Snackbar open={openSnackbar} autoHideDuration={3000} onClose={handleCloseAlert}>
            <Alert onClose={handleCloseAlert} severity="success" sx={{ width: '100%' }}>
              Report permission saved succussfully 
            </Alert>
        </Snackbar>
        { spinnerRPLoad && (<Spinner />) }
    </Box>
  );
};

export default ReportPermission;